import React, { useRef, useState, useImperativeHandle, forwardRef, useContext, useEffect } from "react";
import { personalParticularsData } from "./PersonalParticulars.Data";
import FormCreator from "../../../../../components/Forms/FormCreator";
import { EditApplicationDataContext } from "../../../../../pages/gmap/gmapApplicationTasklist/gmapApplicationTaskListNewApplication/GmapApplicationTaskListNewApplication";
import { useParams } from "react-router-dom";
import { decryptAESID } from "../../../../../utils/Encryption";
import { useSaveGMAPDocumentsMutation, useStoreBase64ImageMutation } from "../../../../../app/services/common/commonApi";
import ToastService from "../../../../../services/toastService/ToastService";
import CenterModel from "../../../../../components/ui/centerModel/CenterModel";
import { APIUrl } from "../../../../../utils/API/fetchBaseQuery";
import SwalAlert from "../../../../../services/swalService/SwalService";

const PersonalParticulars = forwardRef((props, ref) => {
    const personalParticularsRef = useRef();
    const [PersonalParticularsForm, SetPersonalParticulars] = useState(personalParticularsData);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [profilePhoto, setProfilePhoto] = useState(null)
    const { newMemberData, setContextData } = useContext(EditApplicationDataContext)
    const { id } = useParams();
    const { error } = SwalAlert();
    const editID = id ? decryptAESID(id, false) : 0
    const [saveMainImage,
        { isSuccess: isSuccessImage,
            isLoading: isLoadingImage,
            data: profileImageUpload }
    ] = useStoreBase64ImageMutation();

    const [updateFileName,
        { isSuccess: isSuccessFile,
            isLoading: isLoadingFile,
            data: updateFileUpload }
    ] = useSaveGMAPDocumentsMutation();

    useEffect(() => {
        if (isSuccessFile && updateFileUpload) {
            ToastService.success("Profile Photo upload successfuly.")
        }
    }, [isSuccessFile, updateFileUpload]);

    useImperativeHandle(ref, () => ({
        getFormData: () => {
            if (ref?.current) {
                const personalParticularData = personalParticularsRef.current.getFormData();
                return personalParticularData;
            }
            return null;
        }
    }))
    const handleClear = () => {
        const updatedForm = { ...PersonalParticularsForm };
        updatedForm.initialState.profilePhotoFile = null;
        SetPersonalParticulars(updatedForm);
    }

    const handleDownload = (data) => {
        if (props.onDownload) {
            props.onDownload(data);
        }
    };
    const handleViewImage = (formdata) => {
        setIsModalOpen(true);
    }

    const formActionHandler = {
        CLEAR: handleClear,
        DOWNLOAD: handleDownload,
        VIEW_IMAGE: handleViewImage,

    };
    const handleProfileImageUpload = async (data) => {
        const { base64Data, fileName: incomingFileName, name } = data;
        const fileName = incomingFileName || name;

        if (!fileName) {
            error("No file name provided", "File Upload Error");
            return;
        }
        const fileExtension = fileName.split('.').pop().toLowerCase();
        if (fileExtension !== "jpg" && fileExtension !== "png" && fileExtension !== "jpeg") {
            error("Only Image files are allowed", "File Upload Error");
            return;
        }

        const saveFileRequest = {
            fileName,
            fileStr: base64Data,
            storagePath: "ProfessionalProfilePhoto",
        };
        const response = await saveMainImage(saveFileRequest);
        const updateFileRequest = {
            GMAPMemberId: newMemberData.gMAPMemberID,
            ColumnName: "ProfessionalProfilPhoto",
            FileName: response.data?.fileName,
        };
        setProfilePhoto(response.data.fileName);
        setContextData({
            ...newMemberData,
            profilePhotoFile: response.data.fileName,
            profilePhotoFileName: response.data.uploadedFileName
        });
        await updateFileName(updateFileRequest);
    };

    const openModal = () => {
        setIsModalOpen(!isModalOpen);
    }
    const handleFormFieldChange = (dataField, value) => {
        if (dataField === "profilePhotoFile" && value) {
            handleProfileImageUpload(value)
        }
    }

    return (
        <React.Fragment>
            <div className="common-cpd-submission-description-parent">
                <div className="common-project-info-main">
                    <div className="row gx-5">
                        <FormCreator
                            ref={personalParticularsRef}
                            {...personalParticularsData}
                            onFormFieldValueChange={handleFormFieldChange}
                            onActionChange={formActionHandler}
                        />
                    </div>
                </div>
            </div>
            {isModalOpen &&
                <CenterModel
                    modelTitle={'View Image'}
                    show={"test"}
                    handleClose={openModal}
                    onUpload={openModal}
                >
                    <img
                        src={`${APIUrl}/Common/getImage?type=professionalprofilephoto&fileName=${newMemberData?.profilePhotoFile || props?.profilePhotoFile || profilePhoto}`}
                        alt="Uploaded Image"
                    />
                </CenterModel>
            }
        </React.Fragment>
    );
})

export default PersonalParticulars;
